<template>
    <div class="filter-bar">
        <div class="filter-bar__left">
            <div class="filter-bar__results">
                <span class="number" id="filter-bar-total">-</span>
                <span class="text">resultaten</span>
            </div>
        </div>
        <div class="filter-bar__right">
            <button v-if="$store.state.filterState" @click="resetAllFilters" class="filter-reset button">
                <span>Reset all filters</span>
            </button>
            <button @click="toggleFilterVisibility" class="filter-toggle button">
                <span>Filter</span>
            </button>
        </div>
    </div>
</template>

<script>

    import { useStore } from 'vuex';
    export default {
        props: ['FilterBar'],

        methods: {
            resetAllFilters() {
                this.$store.commit('resetFilters');
            },
            toggleFilterVisibility() {
                this.$store.state.filtersShow = true;
            },
            toggleExternalFilterVisibility() {
                const store = useStore();
                document.addEventListener('click', function(event) {
                    if (event.target.classList.contains('filter-external-toggle')) {
                        store.state.filtersShow = true;
                    }
                });

            }
        },
        mounted() {
            this.toggleExternalFilterVisibility();
        }
    };
</script>
